import { roles } from "@constants";

//export const isAdmin = (role: string) => roles.admin.includes(role);
export const isAdmin = (role: string) =>
  process.env.REACT_APP_APPLICATION
    ? process.env.REACT_APP_APPLICATION === "ADMIN_PANEL"
    : roles.admin.includes(role);
